import { userVisitsArchiveTypes } from './userVisitsArchive.types';

// ACTION CREATORS
export const makeIsFetchingTrue = () => ({
  type: userVisitsArchiveTypes.MAKE_IS_FETCHING_TRUE,
});

export const makeExportIsFetchingTrue = () => ({
  type: userVisitsArchiveTypes.MAKE_EXPORT_IS_FETCHING_TRUE,
});

// POST
export const postUserVisitsData = (data) => ({
  type: userVisitsArchiveTypes.POST_USER_VISITS_DATA,
  payload: data,
});

export const postUserVisitsDataSuccess = (data) => ({
  type: userVisitsArchiveTypes.POST_USER_VISITS_DATA_SUCCESS,
  payload: data,
});
// EXPORT REQUEST
export const exportUserVisitsData = (data) => ({
  type: userVisitsArchiveTypes.EXPORT_USER_VISITS_DATA,
  payload: data,
});

export const exportUserVisitsDataSuccess = (data) => ({
  type: userVisitsArchiveTypes.EXPORT_USER_VISITS_DATA_SUCCESS,
  payload: data,
});